
module.exports = function getResource(label, vars = []) {
    const resources = {
        shopFaves: 'Dénichez parmi vos favoris',
        fromLovesList: 'De votre liste de favoris.'
    };
    return resources[label];
};
